var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error',{attrs:{"name":'403',"desc":'抱歉，你无权访问该页面'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }